import React from "react";
import AddressCard from "../AddressCard";
import SlotsTable from "./pick_slot/SlotsTable";

const SlotBooking = (props) => {
  return (
    <>
      <div className="checkout_subtitle_background">
        <h3 className="checkout_subtitle">BOOK YOUR SLOT</h3>
      </div>
      <div className="break"></div>
      <div className="checkout_form_container">
        <form className="checkout_form" action="">
          <div className="collection_container">
            <h3 className="form_subheader" style={{ marginTop: "0" }}>
              COLLECTION LOCATION
            </h3>
            <AddressCard
              img={require("./../../images/chatters-front-canopy.jpg")}
              line1={"Chatters Restaurant"}
              line2={"58 John Street"}
              line3={"Dunoon"}
              postcode={"PA23 8BJ"}
              mapLink={
                "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1857.0443603408403!2d-4.928728324619774!3d55.95196582041807!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4889a495ae9e5587%3A0x8fb6d4606e4ea952!2sChatters%20Brasserie!5e0!3m2!1sen!2suk!4v1672140163512!5m2!1sen!2suk"
              }
            />
          </div>
          <div>
            <h3
              className={
                props.invalidFields.includes("Pick a slot")
                  ? "form_subheader invalid_font"
                  : "form_subheader"
              }
            >
              PICK A SLOT
            </h3>
            <ul>
              <li>
                <span className="slot_info_bullets">
                  We’ll send you a reminder email the day before your chosen slot.
                </span>
              </li>
            </ul>
            <SlotsTable
              slotTaken={props.slotTaken}
              invalidFields={props.invalidFields}
              getDates={props.getDates}
              basket={props.basket}
              slot={props.slot}
              reservedSlot={props.reservedSlot}
              reservedSlotLoading={props.reservedSlotLoading}
              formatReservedSlotDate={props.formatReservedSlotDate}
              setSlot={props.setSlot}
              setNoAvailableSlots={props.setNoAvailableSlots}
              formatReservationExpiryTime={props.formatReservationExpiryTime}
            />
          </div>
          <div>
            <label htmlFor="delivery_notes">Notes</label>
            <textarea
              id="delivery_notes"
              name="delivery_notes"
              value={props.notes}
              onChange={(e) => props.setNotes(e.target.value)}
            ></textarea>
          </div>
        </form>
      </div>
    </>
  );
};

export default SlotBooking;
